module.exports = __webpack_public_path__ + "static/media/sunset.408c1f50.jpg";